import { Typography, Box } from '@mui/material';

import SectionTitle from '../../components/SectionTitle';

const contents = [
  'Trong một số trường hợp có thể có những lựa chọn khác để truyền máu và những lựa chọn này bao gồm thay thế chất lỏng bằng nước muối hoặc các hợp chất nhân tạo khác và/hoặc bổ\nsung sắt.',
  'Bác sĩ của bạn sẽ thảo luận điều này với hoặc vì một số lựa chọn không phù hợp với tất cả mọi người.',
  '(Bác sĩ để tài liệu trong phạm vi được cung cấp. Tiếp tục ghi vào hồ sơ y tế nếu cần thiết.)',
];

const contents2 = [
  '((Bác sĩ ghi vào chỗ trống được cung cấp. Tiếp tục trong Hồ sơ bệnh án nếu cần.)',
];

const DEContents = () => {
  return (
    <>
      <SectionTitle title="D. Các lựa chọn điều trị liên quan khác" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '20px',
              whiteSpace: 'pre',
              marginBottom: '20px',
            }}
          >
            {v}
          </Typography>
        ))}
      </Box>

      <SectionTitle title="E. Nguy cơ không có máu và/hoặc các sản phẩm máu truyền máu" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents2.map((v, i) => (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '38px',
              whiteSpace: 'pre',
            }}
          >
            {v}
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default DEContents;
